import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { ContactFilterApproximation } from '../../extViewmodels/sdk/models/Contact';
import { ContactFilterRequest } from '../../extViewmodels/sdk/models/requests/ContactFilterRequest';
import { useUserSession } from '../../models/hooks/appStateHooks';

const BASE_API_KEY = '/contact/approximate';

export const useContactApproximateQuery = ({
	filterRequest,
	enabled,
	capabilities,
	emailSendCategory,
	impersonationContext,
	impUserId,
	refetchOnWindowFocus = false,
}: {
	filterRequest: ContactFilterRequest;
	enabled?: boolean;
	capabilities: Api.ContactCapability[];
	emailSendCategory?: Api.ContactEmailApproximation;
	impersonationContext?: Api.IImpersonationContext;
	impUserId?: string;
	refetchOnWindowFocus?: boolean;
}) => {
	const userSession = useUserSession();
	return useQuery({
		enabled,
		queryFn: async () => {
			const body = {
				totalCountFilter: filterRequest,
				capabilities,
				emailSendCategory,
			};

			const data = await userSession.webServiceHelper.callAsync(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					urlPath: `contact/approximate${impUserId ? `?impUserId=${impUserId}` : ''}`,
				}),
				'POST',
				body
			);
			return data as ContactFilterApproximation;
		},
		queryKey: [BASE_API_KEY, filterRequest, capabilities],
		refetchOnWindowFocus,
	});
};
